export default __webpack_public_path__ + "b2340cabe2bc9236798fa7c501d0ad55.svg";